import { EditingMode, PermissionRole } from '@aline/common';

export function editingModeEnabledForUser(
  editingMode: EditingMode,
  permissionRole: PermissionRole | null
): boolean {
  if (!permissionRole) return false;

  switch (permissionRole) {
    case PermissionRole.Owner:
    case PermissionRole.Editor:
      return true;
    case PermissionRole.Suggester:
      return editingMode !== EditingMode.EDITING;
    case PermissionRole.Commenter:
      return [EditingMode.COMMENTING, EditingMode.VIEWING].includes(editingMode);
    case PermissionRole.Viewer:
      return editingMode === EditingMode.VIEWING;
  }
}
